import React from 'react';

export const Cordless = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
    >
      <defs>
        <clipPath id="clip-path">
          <circle fill="none" cx="44.22" cy="44.22" r="36.5" />
        </clipPath>
      </defs>
      <circle
        fill="#fff"
        stroke="#27375f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.45px"
        cx="44.22"
        cy="44.22"
        r="43.5"
      />
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.67, 0.74, -0.74, 0.67, 13.77, 66.97)"
      >
        C
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(20.53 74.04) rotate(31.97)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(30.22 79.58) rotate(16.3)"
      >
        R
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(1, 0.02, -0.02, 1, 39.46, 82.02)"
      >
        D
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.98, -0.22, 0.22, 0.98, 49.86, 81.82)"
      >
        L
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(57.42 79.95) rotate(-24.77)"
      >
        E
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(64.92 76.22) rotate(-37.09)"
      >
        S
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.66, -0.75, 0.75, 0.66, 71.15, 71.24)"
      >
        S
      </text>
      <g clipPath="url(#clip-path)">
        <rect
          fill="#27375f"
          opacity="0.31"
          stroke="#fff"
          strokeMiterlimit="10"
          x="-6.2"
          y="-21.02"
          width="102"
          height="58"
        />
        <rect
          stroke="#fff"
          strokeMiterlimit="10"
          fill="#27375f"
          x="-6.2"
          y="36.98"
          width="102"
          height="8"
        />
        <path
          fill="#fff"
          d="M54.14,34.2a4.27,4.27,0,0,0-2.36.72,4.24,4.24,0,0,0-6.35-2.12,4.24,4.24,0,0,0-8,0,4.25,4.25,0,0,0-6.6,3.52v4.86l-2.06,2.06a7.4,7.4,0,0,0-2.17,5.25V51.7a7.36,7.36,0,0,0,2.17,5.24L33,61.18A16.25,16.25,0,0,0,44.6,66,13.78,13.78,0,0,0,58.37,52.21V38.44A4.24,4.24,0,0,0,54.14,34.2Zm2.12,18A11.66,11.66,0,0,1,44.6,63.86a14.19,14.19,0,0,1-10.1-4.18l-4.23-4.23a5.31,5.31,0,0,1-1.56-3.75V48.49a5.27,5.27,0,0,1,1.56-3.75l.56-.56v1.68a1.06,1.06,0,0,0,2.12,0V41.62h0v-5.3a2.12,2.12,0,0,1,4.24,0V39.5a1.06,1.06,0,0,0,2.12,0V34.2a2.12,2.12,0,0,1,4.23,0v5.3a1.06,1.06,0,0,0,2.12,0V36.32a2.12,2.12,0,0,1,4.24,0V39.5a1.06,1.06,0,0,0,2.12,0V38.44a2.12,2.12,0,0,1,4.24,0Z"
        />
        <path
          fill="#27375f"
          d="M56.26,52.21A11.66,11.66,0,0,1,44.6,63.86a14.19,14.19,0,0,1-10.1-4.18l-4.23-4.23a5.31,5.31,0,0,1-1.56-3.75V48.49a5.27,5.27,0,0,1,1.56-3.75l.56-.56v1.68a1.06,1.06,0,0,0,2.12,0V41.62h0v-5.3a2.12,2.12,0,0,1,4.24,0V39.5a1.06,1.06,0,0,0,2.12,0V34.2a2.12,2.12,0,0,1,4.23,0v5.3a1.06,1.06,0,0,0,2.12,0V36.32a2.12,2.12,0,0,1,4.24,0V39.5a1.06,1.06,0,0,0,2.12,0V38.44a2.12,2.12,0,0,1,4.24,0Z"
        />
      </g>
    </svg>
  );
};
